import { useIsTipEnabled } from 'reservations/account/providers/ConfigProvider';
import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { BaseCardModal } from 'reservations/checklessPayments/components/BaseCardModal';
import { RetrieveTokenButton } from 'reservations/checklessPayments/components/RetrieveTokenButton';
import { RetrieveTokenButtonV2 } from 'reservations/checklessPayments/components/RetrieveTokenButtonV2';
import { SaveChecklessButton } from 'reservations/checklessPayments/components/SaveChecklessButon';
import { SaveNewPaymentButton } from 'reservations/checklessPayments/components/SavePaymentButton';
import {
  SAVE_YOUR_CARD_HEADER,
  SAVE_YOUR_CARD_SUBHEADER
} from 'reservations/checklessPayments/constants';

const AddCardModal = () => {
  const isTipEnabled = useIsTipEnabled();
  const hasVisitId = useHasVisitId();
  const { open } = useModal();

  const TokenButton = hasVisitId ? RetrieveTokenButtonV2 : RetrieveTokenButton;
  const PaymentButton = hasVisitId ? SaveChecklessButton : SaveNewPaymentButton;
  const Button = isTipEnabled ? TokenButton : PaymentButton;

  return (
    <BaseCardModal
      headerText={SAVE_YOUR_CARD_HEADER}
      subheaderText={SAVE_YOUR_CARD_SUBHEADER}
      Button={Button}
      handleClick={() =>
        open(
          isTipEnabled
            ? ModalType.ChecklessAddTip
            : ModalType.ChecklessEnrollmentComplete
        )
      }
    />
  );
};

export default AddCardModal;
